import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import { BrowserRouter } from "react-router-dom";
import { IngredientsProvider } from "./context/IngredientsProvider";

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);

root.render(
  <React.StrictMode>
    <BrowserRouter>
      <IngredientsProvider>
        <App />
      </IngredientsProvider>
    </BrowserRouter>
  </React.StrictMode>
);
